/* eslint-disable unicorn/prefer-module */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import React, { useCallback, useEffect, useState, useMemo } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import { Loader } from "..";
import { useAuthContext } from "../../context/auth";
import { getOportunidades, getIntermediarios, getEdificiosOperativos, getUsers, getClientes, getOportunidadesBTL, log, calculateComission } from "../../utils";
import "./stylesVentasFacturasEjecutivo.scss";

export const VentasFacturasEjecutivo = () => {
  const [todasOportunidades, setTodasOportunidades] = useState([]);
  const [oportunidadesFiltradas, setOportunidadesFiltradas] = useState([]);
  const [intermediarios, setIntermediarios] = useState([]);
  const [filtroNumeroFactura, setFiltroNumeroFactura] = useState("");
  const [filtroCliente, setFiltroCliente] = useState("");
  const [filtroCobrada, setFiltroCobrada] = useState("");
  const [numerosFacturaUnicos, setNumerosFacturaUnicos] = useState([]);
  const [clientesUnicos, setClientesUnicos] = useState([]);
  const [filtroAno, setFiltroAno] = useState(new Date().getFullYear().toString());
  const [filtroMeses, setFiltroMeses] = useState([]);
  const [filtroIntermediario, setFiltroIntermediario] = useState("");
  const [intermediariosUnicos, setIntermediariosUnicos] = useState([]);
  const [edificios, setEdificios] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filtroEjecutivo, setFiltroEjecutivo] = useState("");
  const [, setEjecutivosUnicos] = useState([]);
  const [ejecutivos, setEjecutivos] = useState({});
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [clientes, setClientes] = useState([]);
  const { pais, id, rol } = useAuthContext();
  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
        Uruguay: "es-UY",
      }[pais] || "es-UY"),
    []
  );
  const moneda = useCallback(
    (pais) =>
      ({
        Chile: "$",
        Perú: "S/",
        Uruguay: "$",
      }[pais] || "$"),
    []
  );
  const decimales = useCallback(
    (pais) =>
      ({
        Chile: 0,
        Perú: 2,
        Uruguay: 0,
      }[pais] || 0),
    []
  );
  const logo = useMemo(
    () =>
      ({
        Chile: require("../../img/wecast-logo.png"),
        Perú: require("../../img/visiona-logo.png"),
        Uruguay: require("../../img/screenmedia-logo.png"),
        Region: require("../../img/adigital-logo.png"),
      })[pais] || require("../../img/visiona-logo.png"),
    [pais]
  );
  const mesEnLetras = useCallback((mes) => {
    const mesesEnLetras = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    return mesesEnLetras[parseInt(mes, 10) - 1] || "";
  }, []);

  const esGerenciaOAdministracion = ["gerencia", "administrativo"].includes(rol.toLowerCase());
  const ejecutivosUnicos = useMemo(() => [...new Set(todasOportunidades.map((o) => o.ejecutivo))]
    .filter(ejecutivo => ejecutivo && ejecutivo !== "null" && ejecutivo !== "")
    .sort(), [todasOportunidades]);

  useEffect(() => {
    const fetchData = async () => {
      try {
      // Define exchange rates for PAUTA opportunities
        const tiposDeCambio = {
          Uruguay: 40,
          Perú: 3.75,
          Chile: 950,
        };
        // Fetch PAUTA opportunities, intermediaries, buildings, and clients
        const [allOportunidades, allIntermediarios, edificiosData, allClientes] = await Promise.all([
          getOportunidades({ pais }),
          getIntermediarios({ pais }),
          getEdificiosOperativos({ pais }),
          getClientes({ pais }),
        ]);

        // Convert to maps for efficient lookups
        const clientesMap = allClientes.reduce((acc, c) => {
          if (acc[c.id]) log.warn(`Duplicate client ID: ${c.id}`);
          acc[c.id] = c;
          return acc;
        }, {});

        const intermediariosMap = allIntermediarios.reduce((acc, i) => {
          if (acc[i.id]) log.warn(`Duplicate intermediary ID: ${i.id}`);
          acc[i.id] = i;
          return acc;
        }, {});

        const edificiosMap = edificiosData.reduce((acc, e) => {
          if (acc[e.id]) log.warn(`Duplicate edificio ID: ${e.id}`);
          acc[e.id] = e;
          return acc;
        }, {});

        // Adjust PAUTA opportunities' importe if moneda_dolar === true
        const pautaOportunidadesAjustadas = allOportunidades.map((oportunidad) => {
          if (oportunidad.moneda_dolar === true) {
            const tipoCambio = tiposDeCambio[pais] || 1;
            return {
              ...oportunidad,
              importe: oportunidad.importe * tipoCambio,
            };
          }
          return oportunidad;
        });
        // Filter PAUTA opportunities based on user role and clean invalid ejecutivo
        const userOportunidades = esGerenciaOAdministracion
          ? pautaOportunidadesAjustadas
          : pautaOportunidadesAjustadas.filter((oportunidad) => oportunidad.ejecutivo === id.toString());
        // Validate and clean ejecutivo field
        const invalidOportunidades = userOportunidades.filter(op => !op.ejecutivo || op.ejecutivo === "null" || op.ejecutivo === "");
        if (invalidOportunidades.length > 0) {
          log.warn(`Found ${invalidOportunidades.length} opportunities with missing or invalid ejecutivo fields`, invalidOportunidades);
        }
        const cleanedOportunidades = userOportunidades.map(op => ({
          ...op,
          ejecutivo: op.ejecutivo && op.ejecutivo !== "null" && op.ejecutivo !== "" ? op.ejecutivo : null,
        }));
        // Mark PAUTA opportunities as non-BTL
        const pautaOportunidades = cleanedOportunidades.map(op => ({ ...op, isBTL: false }));
        // Determine unique years from PAUTA opportunities for fetching BTL sales
        const years = [...new Set(pautaOportunidades
          .map(op => {
            if (op.facturafecha) {
              return new Date(op.facturafecha).getFullYear();
            } else if (op.ano) {
              return parseInt(op.ano, 10);
            }
            return new Date(op.created_at || new Date()).getFullYear();
          })
          .filter(year => year))];
        // Fetch BTL sales for each year
        const btlPromises = years.map(year =>
          getOportunidadesBTL({ pais, ano: year }).catch((error) => {
            log.error(`Error fetching BTL opportunities for year ${year}:`, error);
            return [];
          })
        );
        const btlResults = await Promise.all(btlPromises);
        const allBtlSales = btlResults.flat();
        // Normalize and deduplicate BTL sales with cleaned ejecutivo
        const uniqueBtlSales = new Map();
        const userBtlSales = (esGerenciaOAdministracion
          ? allBtlSales
          : allBtlSales.filter((sale) => sale.ejecutivo === id.toString()))
          .filter(sale => {
            if (!sale.id) {
              return false;
            }
            if (uniqueBtlSales.has(sale.id)) {
              return false;
            }
            uniqueBtlSales.set(sale.id, true);
            return true;
          })
          .map(sale => {
            const cliente = allClientes.find(c => c.id === sale.client_id); // Temporary use of array
            const clienteNombre = cliente ? cliente.nombre : "SIN CLIENTE";
            const buildings = sale.buildings
              ? (typeof sale.buildings === "string"
                  ? JSON.parse(sale.buildings)
                  : sale.buildings)
              : [];
            const edificiosParticipantes = buildings.map(b => b.id).join(",") || "";
            let totalImporte = buildings.reduce((sum, building) => sum + (building.importe || 0), 0);
            if (sale.moneda_dolar) { // Add if BTL can be in dollars; adjust if field exists
              const tipoCambio = tiposDeCambio[pais] || 1;
              totalImporte *= tipoCambio;
            }
            const intermediarioNombre = sale.intermediario || "SIN INTERMEDIARIO";
            const intermediarioObj = allIntermediarios.find(i => i.nombre === sale.intermediario);
            const intermediarioId = intermediarioObj ? intermediarioObj.id : null;
            const comisionIntermediario = sale.comision || 0;
            return {
              ...sale,
              cliente: clienteNombre,
              importe: totalImporte,
              edificiosparticipantes: edificiosParticipantes,
              estatus: "100%",
              isBTL: true,
              intermediario: intermediarioNombre,
              intermediarioId, // Added for special cases
              comision: comisionIntermediario,
              ejecutivo: sale.ejecutivo && sale.ejecutivo !== "null" && sale.ejecutivo !== "" ? sale.ejecutivo : null,
            };
          });
        // Merge PAUTA and BTL sales, sort by date
        const combinedOportunidades = [...pautaOportunidades, ...userBtlSales].sort((a, b) => {
          const dateA = a.facturafecha
            ? new Date(a.facturafecha)
            : a.created_at
              ? new Date(a.created_at)
              : new Date();
          const dateB = b.facturafecha
            ? new Date(b.facturafecha)
            : b.created_at
              ? new Date(b.created_at)
              : new Date();
          return dateB - dateA;
        });
        setTodasOportunidades(combinedOportunidades);
        setIntermediarios(intermediariosMap); // Use map
        setEdificios(edificiosMap); // Use map
        setClientes(clientesMap); // Use map
        const intermediariosUnicos = [...new Set(Object.values(intermediariosMap).map((i) => i.nombre))].sort();
        setIntermediariosUnicos(intermediariosUnicos);
        const allUsers = await getUsers();
        if (!allUsers || allUsers.length === 0) {
          log.error("Failed to fetch users or empty user data returned");
          setEjecutivos({});
          return;
        }
        const ejecutivosMap = allUsers.reduce((acc, user) => {
          acc[user.id] = user.nombre;
          return acc;
        }, {});
        setEjecutivos(ejecutivosMap);
      } catch (error) {
        log.error("Error fetching data:", error);
        toast.error("Hubo un error al cargar los datos.");
      } finally {
        setIsLoading(false);
      }
    };
    setIsLoading(true);
    fetchData();
  }, [pais, id, rol, esGerenciaOAdministracion]);

  useEffect(() => {
    const filtrarOportunidades = () => {
      const yearSeleccionado = filtroAno ? parseInt(filtroAno, 10) : null;
      const filtradas = todasOportunidades
        .filter((oportunidad) => {
          const fechaFactura = oportunidad.facturafecha ? new Date(oportunidad.facturafecha) : null;
          const mesFactura = fechaFactura ? (fechaFactura.getMonth() + 1).toString().padStart(2, "0") : null;
          const mesFiltrado =
          filtroMeses.length > 0
            ? filtroMeses.includes(mesFactura) || filtroMeses.includes(oportunidad.mes)
            : true;
          const intermediarioFiltrado = filtroIntermediario
            ? oportunidad.intermediario === filtroIntermediario
            : true;
          const perteneceAlAno = yearSeleccionado
            ? parseInt(oportunidad.ano, 10) === yearSeleccionado ||
            (fechaFactura && fechaFactura.getFullYear() === yearSeleccionado)
            : true;
          return (
            mesFiltrado &&
          intermediarioFiltrado &&
          (filtroNumeroFactura ? oportunidad.facturanumero === filtroNumeroFactura : true) &&
          (filtroCliente ? oportunidad.cliente === filtroCliente : true) &&
          (filtroCobrada
            ? filtroCobrada === "Sí"
              ? oportunidad.facturafechacobro
              : !oportunidad.facturafechacobro
            : true) &&
          perteneceAlAno &&
          (filtroEjecutivo ? oportunidad.ejecutivo === filtroEjecutivo : true) &&
          oportunidad.estatus === "100%" &&
          !oportunidad.eliminada
          );
        })
        .map((oportunidad) => {

          const comisionIntermediario = calculateComission.calculateAgencyCommission(oportunidad, clientes, intermediarios);

          let intermediarioNombre = "SIN INTERMEDIARIO";
          let comisionIntermediarioPorcentaje = 0;
          // REMOVIDO: if (comisionIntermediario > 0 && oportunidad.importe > 0) { comisionIntermediarioPorcentaje = (comisionIntermediario / oportunidad.importe) * 100; }
          // Usa el raw porcentaje del logic en calculateAgencyCommission (whole number from DB)
          if (!oportunidad.isBTL) {
            const clienteAsociado = clientes[oportunidad.client_id];
            if (clienteAsociado && clienteAsociado.agencia) {
              const intermediarioAsociado = intermediarios[clienteAsociado.agencia];
              if (intermediarioAsociado) {
                intermediarioNombre = intermediarioAsociado.nombre;
                const fechaFactura = new Date(oportunidad.facturafecha || oportunidad.created_at || new Date());
                comisionIntermediarioPorcentaje =
                intermediarioAsociado.comision_2 &&
                intermediarioAsociado.comision_2_fechainicio &&
                intermediarioAsociado.comision_2_fechafin &&
                fechaFactura >= new Date(intermediarioAsociado.comision_2_fechainicio) &&
                fechaFactura <= new Date(intermediarioAsociado.comision_2_fechafin)
                  ? intermediarioAsociado.comision_2 || 0
                  : intermediarioAsociado.comision || 0;
                if ([16, 32, 60].includes(clienteAsociado.agencia)) comisionIntermediarioPorcentaje = 0;
              }
            }
          } else if (oportunidad.isBTL && oportunidad.intermediario) {
            intermediarioNombre = oportunidad.intermediario;
            comisionIntermediarioPorcentaje = oportunidad.comision || 0;
            if ([16, 32, 60].includes(oportunidad.intermediarioId)) comisionIntermediarioPorcentaje = 0;
          }

          const comisionEdificio = calculateComission.calculateBuildingCommission(oportunidad, edificios);
 
          const neto = Math.max(0, oportunidad.importe - comisionIntermediario - comisionEdificio); // Asegurar neto no negativo

          const comisionVendedor = calculateComission.calculateSalesCommission(oportunidad, clientes, intermediarios, edificios);
 
          const result = {
            ...oportunidad,
            intermediario: intermediarioNombre,
            comision: comisionIntermediarioPorcentaje,
            comisionedificio: comisionEdificio,
            comisionvendedor: comisionVendedor,
            neto: neto,
            edificiosparticipantes: String(oportunidad.edificiosparticipantes),
          };
          return result;
        });
      setOportunidadesFiltradas(filtradas);
      const numerosFactura = [...new Set(filtradas.map((o) => o.facturanumero))]
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
      setNumerosFacturaUnicos(numerosFactura);
      const clientesUnicos = [...new Set(filtradas.map((o) => o.cliente))].filter(Boolean).sort();
      setClientesUnicos(clientesUnicos);
    };
    setEjecutivosUnicos(ejecutivosUnicos);
    if (todasOportunidades.length > 0 && Object.keys(edificios).length > 0 && Object.keys(clientes).length > 0) {
      filtrarOportunidades();
    }
  }, [
    filtroMeses,
    filtroNumeroFactura,
    filtroCliente,
    filtroCobrada,
    filtroAno,
    filtroIntermediario,
    todasOportunidades,
    intermediarios,
    edificios,
    clientes,
    filtroEjecutivo,
    ejecutivosUnicos,
  ]);
  
  const calcularTotales = () => {
    let totalVenta = 0;
    let totalComisionIntermediario = 0;
    let totalComisionEdificio = 0;
    let totalComisionVendedor = 0;
    let totalNeto = 0;

    oportunidadesFiltradas.forEach((oportunidad) => {
      const importe = oportunidad.importe || 0;
      totalVenta += importe;
      // Comisión de Agencias: Usa el % precalculado y aplica al importe
      totalComisionIntermediario += (oportunidad.comision / 100) * importe || 0;
      // Comisión de Edificios: Suma el valor precalculado
      totalComisionEdificio += oportunidad.comisionedificio || 0;
      // Comisión Comercial: Suma el valor precalculado
      totalComisionVendedor += oportunidad.comisionvendedor || 0;
      // Neto: Suma el valor precalculado
      totalNeto += oportunidad.neto || 0;
    });

    return {
      totalVenta,
      totalComisionIntermediario,
      totalComisionEdificio,
      totalNeto,
      totalComisionVendedor,
    };
  };
  
  const totales = calcularTotales();
  const fecha = { day: "2-digit", month: "2-digit", year: "numeric" };
  if (todasOportunidades.length === 0 || intermediarios.length === 0) return <Loader />;
  const renderMesOptions = () =>
    ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"].map((mes, index) => {
      const mesValue = index < 9 ? `0${index + 1}` : `${index + 1}`;
      return (
        <div key={index} className="form-check d-flex align-items-center mes-option">
          <input
            className="form-check-input"
            type="checkbox"
            id={`mes-${index}`}
            value={mesValue}
            checked={filtroMeses.includes(mesValue)}
            onChange={(e) => handleMesChange(e.target.value)}
          />
          <label className="form-check-label" htmlFor={`mes-${index}`}>
            {mes}
          </label>
        </div>
      );
    });
  const handleMesChange = (mes) => {
    setFiltroMeses((prev) => (prev.includes(mes) ? prev.filter((item) => item !== mes) : [...prev, mes]));
  };

  const BuildingDetailsModal = ({ opportunity, buildings, moneda, localString, decimales, onClose }) => {
    let buildingDetails = [];
    if (opportunity.edificiosparticipantes && typeof opportunity.edificiosparticipantes === "string") {
    // Eliminar IDs duplicados usando Set
      const edificiosParticipantesUnicos = [...new Set(opportunity.edificiosparticipantes.split(",").map(Number))];
      // Calcular comisionIntermediario y netoParaEdificios para consistencia
      const comisionIntermediario = calculateComission.calculateAgencyCommission(opportunity, clientes, intermediarios);
      const netoParaEdificios = opportunity.importe - comisionIntermediario;
      // Calcular total de pantallas usando Object.values para el map
      const totalPantallas = Object.values(buildings).reduce(
        (sum, ed) =>
          edificiosParticipantesUnicos.includes(ed.id)
            ? sum + (Number(ed.pantallas || 0)) + (Number(ed.totems || 0)) + (Number(ed.espera || 0)) + (Number(ed.cowork || 0))
            : sum,
        0
      );
      const totalComision = calculateComission.calculateBuildingCommission(opportunity, buildings);
      let totalInvestment = 0;
      let fechaFactura;
      // Usar mes_factura si existe, en formato MM-YYYY, ignorando mes_old
      if (opportunity.mes_factura && typeof opportunity.mes_factura === "string") {
        const [mes, ano] = opportunity.mes_factura.split("-").map(Number);
        fechaFactura = new Date(Date.UTC(ano, mes - 1, 1)); // Mes 0-based, día 1 en UTC
      } else if (opportunity.facturafecha) {
        fechaFactura = new Date(opportunity.facturafecha);
      } else {
        const mes = opportunity.mes ? parseInt(opportunity.mes, 10) : 1; // Fallback a mes si no hay mes_factura
        const ano = opportunity.ano ? parseInt(opportunity.ano, 10) : new Date().getFullYear(); // Fallback a ano
        fechaFactura = new Date(Date.UTC(ano, mes - 1, 1)); // UTC para consistencia
      }
      // Usar los IDs únicos para generar los detalles
      buildingDetails = edificiosParticipantesUnicos
        .map((buildingId) => {
          const building = buildings[buildingId];
          if (!building) {
            return null;
          }
          let comisionPercent = 0;
          const periods = [
            { inicio: building.comision_1_fechainicio, fin: building.comision_1_fechafin, porcentaje: building.comision_1_porcentaje },
            { inicio: building.comision_2_fechainicio, fin: building.comision_2_fechafin, porcentaje: building.comision_2_porcentaje },
            { inicio: building.comision_3_fechainicio, fin: building.comision_3_fechafin, porcentaje: building.comision_3_porcentaje },
          ].filter((p) => p.inicio && p.fin);
          for (const period of periods) {
            const inicioDate = new Date(period.inicio);
            const finDate = new Date(period.fin);
            if (fechaFactura >= inicioDate && fechaFactura <= finDate) {
              comisionPercent = period.porcentaje || 0;
              break;
            }
          }
          if (comisionPercent === 0 && periods.length > 0) {
            comisionPercent = periods[0].porcentaje || 0; // Fallback al primer porcentaje si no hay match
          } else if (comisionPercent === 0) {
            console.log(`No match for ${building.edificio}, defaulting to 0%`);
          }
          const pantallasEdificio =
          Number(building.pantallas || 0) +
          Number(building.totems || 0) +
          Number(building.espera || 0) +
          Number(building.cowork || 0);
          const proporcion = totalPantallas > 0 ? pantallasEdificio / totalPantallas : 1;
          const inversionNeta = netoParaEdificios * proporcion;
          const comisionEdificio = inversionNeta * (comisionPercent / 100);
          totalInvestment += inversionNeta;
          return {
            name: building.edificio || "Unknown",
            comision: comisionEdificio.toFixed(0),
            percent: comisionPercent.toFixed(1),
            pantallas: pantallasEdificio,
            importeInversion: inversionNeta.toFixed(0),
          };
        })
        .filter(Boolean);
      buildingDetails.sort((a, b) => a.name.localeCompare(b.name));
      buildingDetails.push({
        name: "Total",
        comision: totalComision.toFixed(0),
        percent: buildingDetails.length > 1 ? ((totalComision / netoParaEdificios) * 100).toFixed(1) : buildingDetails[0].percent,
        pantallas: totalPantallas,
        importeInversion: totalInvestment.toFixed(0),
      });
    }
    return (
      <Modal show={!!opportunity} onHide={onClose} dialogClassName="wide-modal">
        <Modal.Header closeButton>
          <Modal.Title>DETALLE DEL CÁLCULO DE LA COMISIÓN DE LOS EDIFICIOS</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {buildingDetails.length > 0 ? (
            <div style={{ overflowX: "auto" }}>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th style={{ width: "45%" }}>EDIFICIOS INVOLUCRADOS</th>
                    <th className="text-end" style={{ width: "15%" }}>
                    PANTALLAS
                    </th>
                    <th className="text-end" style={{ width: "15%" }}>
                    INVERSIÓN NETA POR EDIFICIO
                    </th>
                    <th className="text-end" style={{ width: "15%" }}>
                    COMISIÓN DEL EDIFICIO
                    </th>
                    <th className="text-end" style={{ width: "15%" }}>
                    COSTO DE LA COMISIÓN
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {buildingDetails.map((detail, index) => (
                    <tr key={index} className={detail.name === "Total" ? "table-info" : ""}>
                      <td className="text-start">{detail.name.toUpperCase()}</td>
                      <td className="text-end">{detail.pantallas}</td>
                      <td className="text-end">{`${moneda.toUpperCase()} ${Number(
                        detail.importeInversion
                      ).toLocaleString(localString, {
                        maximumFractionDigits: decimales,
                        minimumFractionDigits: decimales,
                      })}`}</td>
                      <td className="text-end">
                        {detail.percent
                          ? `${Number(detail.percent).toLocaleString(localString, {
                            maximumFractionDigits: 1,
                            minimumFractionDigits: 1,
                          })}%`
                          : "-"}
                      </td>
                      <td className="text-end">{`${moneda.toUpperCase()} ${Number(
                        detail.comision
                      ).toLocaleString(localString, {
                        maximumFractionDigits: decimales,
                        minimumFractionDigits: decimales,
                      })}`}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>NO HAY DETALLES DE EDIFICIOS DISPONIBLES PARA ESTA OPORTUNIDAD.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={onClose}>
          CERRAR
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  if (isLoading) return <Loader />;
  return (
    <>
      <div className="mis-facturas">
        <div className="logo-container mb-4">
          <img src={logo} alt={`${pais} Logo`} className="logo" />
        </div>
        <div className="table-responsive">
          {/* Mini Dashboard */}
          <div className="row justify-content-center mb-2">
            <div className="col-md-2">
              <div className="card text-white" style={{ backgroundColor: "#343a40" }}>
                <div className="card-header text-center" style={{ borderBottom: "1px solid #ffffff" }}>
                  BRUTO
                </div>
                <div className="card-body text-center">
                  <h5 className="card-title">{`${moneda(pais)} ${
                    totales.totalVenta !== undefined && totales.totalVenta !== null
                      ? totales.totalVenta.toLocaleString(localString(pais), {
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0,
                      })
                      : "0"
                  }`}</h5>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="card text-white" style={{ backgroundColor: "#343a40" }}>
                <div className="card-header text-center" style={{ borderBottom: "1px solid #ffffff" }}>
                  COMISIÓN AGENCIAS
                </div>
                <div className="card-body text-center">
                  <h5 className="card-title">{`${moneda(pais)} ${
                    totales.totalComisionIntermediario !== undefined && totales.totalComisionIntermediario !== null
                      ? totales.totalComisionIntermediario.toLocaleString(localString(pais), {
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0,
                      })
                      : "0"
                  }`}</h5>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="card text-white" style={{ backgroundColor: "#343a40" }}>
                <div className="card-header text-center" style={{ borderBottom: "1px solid #ffffff" }}>
                  COMISIÓN EDIFICIOS
                </div>
                <div className="card-body text-center">
                  <h5 className="card-title">{`${moneda(pais)} ${
                    totales.totalComisionEdificio !== undefined && totales.totalComisionEdificio !== null
                      ? totales.totalComisionEdificio.toLocaleString(localString(pais), {
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0,
                      })
                      : "0"
                  }`}</h5>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="card text-white" style={{ backgroundColor: "#343a40" }}>
                <div className="card-header text-center" style={{ borderBottom: "1px solid #ffffff" }}>
                  NETO
                </div>
                <div className="card-body text-center">
                  <h5 className="card-title">{`${moneda(pais)} ${
                    totales.totalNeto !== undefined && totales.totalNeto !== null
                      ? totales.totalNeto.toLocaleString(localString(pais), {
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0,
                      })
                      : "0"
                  }`}</h5>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="card text-white" style={{ backgroundColor: "#343a40" }}>
                <div className="card-header text-center" style={{ borderBottom: "1px solid #ffffff" }}>
                  COMISIÓN COMERCIAL
                </div>
                <div className="card-body text-center">
                  <h5 className="card-title">{`${moneda(pais)} ${
                    totales.totalComisionVendedor !== undefined && totales.totalComisionVendedor !== null
                      ? totales.totalComisionVendedor.toLocaleString(localString(pais), {
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0,
                      })
                      : "0"
                  }`}</h5>
                </div>
              </div>
            </div>
            <div className="row justify-content-center mt-4 mb-3">
              {/* First row */}
              <div className="col-md-2">
                <select
                  className="form-select"
                  value={filtroNumeroFactura}
                  onChange={(e) => setFiltroNumeroFactura(e.target.value)}
                >
                  <option value="">Número de Factura</option>
                  {numerosFacturaUnicos.map((numero) => (
                    <option key={numero} value={numero}>
                      {numero}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                <select
                  className="form-select"
                  value={filtroCliente}
                  onChange={(e) => setFiltroCliente(e.target.value)}
                >
                  <option value="">Cliente Publicitario</option>
                  {clientesUnicos.map((cliente) => (
                    <option key={cliente} value={cliente}>
                      {cliente}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                <Dropdown>
                  <Dropdown.Toggle
                    variant="white border"
                    id="dropdown-basic"
                    className={`form-control dropdown text-start ${filtroMeses.length > 0 ? "active-filter" : ""}`}
                  >
                    {filtroMeses.length > 0 ? filtroMeses.map((mes) => mesEnLetras(mes)).join(", ") : "Mes/meses"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {renderMesOptions()}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="col-md-2">
                <select
                  className="form-select"
                  value={filtroIntermediario}
                  onChange={(e) => setFiltroIntermediario(e.target.value)}
                >
                  <option value="">Intermediario</option>
                  {intermediariosUnicos.map((intermediario) => (
                    <option key={intermediario} value={intermediario}>
                      {intermediario}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row justify-content-center mb-3">
              {/* Second row */}
              <div className="col-md-2">
                <select className="form-select" value={filtroAno} onChange={(e) => setFiltroAno(e.target.value)}>
                  <option value="">HTD</option>
                  {["2024", "2025"].map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                <select
                  className="form-select"
                  value={filtroCobrada}
                  onChange={(e) => setFiltroCobrada(e.target.value)}
                >
                  <option value="">Cobrada</option>
                  <option value="Sí">Sí</option>
                  <option value="No">No</option>
                </select>
              </div>
              <div className="col-md-2">
                <select
                  className="form-select"
                  value={filtroEjecutivo}
                  onChange={(e) => setFiltroEjecutivo(e.target.value)}
                >
                  <option value="">Ejecutivo</option>
                  {ejecutivosUnicos.map((ejecutivoId) => (
                    <option key={ejecutivoId} value={ejecutivoId}>
                      {ejecutivos[ejecutivoId] || ejecutivoId}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-hover table-sm ventas-facturas-table">
              <colgroup>
                <col className="ventas-facturas-tipo-col" />
                <col className="ventas-facturas-cliente-col" />
                <col className="ventas-facturas-numero-col" />
                <col className="ventas-facturas-fecha-col" />
                <col className="ventas-facturas-importe-col" />
                <col className="ventas-facturas-agencia-col" />
                <col className="ventas-facturas-porcentaje-inter-col" />
                <col className="ventas-facturas-importe-inter-col" />
                <col className="ventas-facturas-participantes-col" />
                <col className="ventas-facturas-porcentaje-edificios-col" />
                <col className="ventas-facturas-importe-edificios-col" />
                <col className="ventas-facturas-neto-col" />
                <col className="ventas-facturas-comision-comercial-col" />
                <col className="ventas-facturas-ejecutivo-col" />
              </colgroup>
              <thead className="text-center align-middle">
                <tr>
                  <th rowSpan="2" className="ventas-facturas-tipo-col">TIPO</th>
                  <th rowSpan="2" className="ventas-facturas-cliente-col">CLIENTE</th>
                  <th colSpan="3" className="ventas-facturas-factura-col">FACTURA</th>
                  <th colSpan="3" className="ventas-facturas-intermediario-col">INTERMEDIARIO</th>
                  <th colSpan="3" className="ventas-facturas-comision-edificios-col">COMISIÓN EDIFICIOS</th>
                  <th rowSpan="2" className="ventas-facturas-neto-col">NETO</th>
                  <th rowSpan="2" className="ventas-facturas-comision-comercial-col">COMISIÓN COMERCIAL</th>
                  <th rowSpan="2" className="ventas-facturas-ejecutivo-col">EJECUTIVO</th>
                </tr>
                <tr>
                  <th className="ventas-facturas-numero-col">NÚMERO</th>
                  <th className="ventas-facturas-fecha-col">FECHA</th>
                  <th className="ventas-facturas-importe-col">IMPORTE</th>
                  <th className="ventas-facturas-agencia-col">AGENCIA</th>
                  <th className="ventas-facturas-porcentaje-inter-col">%</th>
                  <th className="ventas-facturas-importe-inter-col">IMPORTE</th>
                  <th className="ventas-facturas-participantes-col">DETALLE</th>
                  <th className="ventas-facturas-porcentaje-edificios-col">%</th>
                  <th className="ventas-facturas-importe-edificios-col">IMPORTE</th>
                </tr>
              </thead>
              <tbody>
                {oportunidadesFiltradas.length === 0 ? (
                  <tr>
                    <td colSpan="14" className="text-center">
            No hay facturas ni ventas según los filtros seleccionados :(
                    </td>
                  </tr>
                ) : (
                  oportunidadesFiltradas.map(
                    ({
                      cliente,
                      comision,
                      comisionedificio,
                      comisionvendedor,
                      estatus,
                      facturafecha,
                      facturanumero,
                      id,
                      importe,
                      intermediario,
                      neto,
                      edificiosparticipantes,
                      isBTL,
                      ejecutivo,
                    }) => (
                      <tr key={id}>
                        <td className="bg-success text-white ventas-facturas-tipo-col">{isBTL ? "BTL" : "PAUTA"}</td>
                        <td className="ventas-facturas-cliente-col text-start">{cliente}</td>
                        <td className="ventas-facturas-numero-col">{facturanumero ? facturanumero : "Pendiente"}</td>
                        <td className="ventas-facturas-fecha-col">
                          {facturafecha
                            ? new Date(facturafecha).toLocaleDateString("es-ES", fecha)
                            : "Pendiente"}
                        </td>
                        <td className="text-end ventas-facturas-importe-col">{`${moneda(pais)} ${
                          importe?.toLocaleString(localString(pais), {
                            maximumFractionDigits: decimales(pais),
                            minimumFractionDigits: decimales(pais),
                          }) || "error"
                        }`}</td>
                        <td className="ventas-facturas-agencia-col text-start">{intermediario}</td>
                        <td className="text-center ventas-facturas-porcentaje-inter-col">
                          {intermediario === "DIRECTO" || intermediario === "SIN INTERMEDIARIO" ? "-" : `${comision.toFixed(0)}%`}
                        </td>
                        <td className="text-end ventas-facturas-importe-inter-col">
                          {intermediario === "DIRECTO" || intermediario === "SIN INTERMEDIARIO"
                            ? "-"
                            : `${moneda(pais)} ${(importe * (comision / 100)).toLocaleString(localString(pais), {
                              maximumFractionDigits: decimales(pais),
                              minimumFractionDigits: decimales(pais),
                            })}`}
                        </td>
                        <td className="ventas-facturas-participantes-col">
                          <span
                            style={{
                              cursor: "pointer",
                              color: "blue",
                              textDecoration: "underline",
                              maxWidth: "100%",
                              overflow: "visible",
                              textOverflow: "clip",
                              display: "block",
                            }}
                            onClick={() =>
                              setSelectedOpportunity({
                                cliente,
                                comision,
                                comisionedificio,
                                comisionvendedor,
                                estatus,
                                facturafecha,
                                facturanumero,
                                id,
                                importe,
                                intermediario,
                                neto,
                                edificiosparticipantes,
                              })
                            }
                          >
                  Detalle
                          </span>
                        </td>
                        <td className="text-center ventas-facturas-porcentaje-edificios-col">{`${Number(
                          (comisionedificio / importe) * 100
                        ).toLocaleString(localString(pais), {
                          maximumFractionDigits: 1,
                          minimumFractionDigits: 1,
                        })}%`}</td>
                        <td className="text-end ventas-facturas-importe-edificios-col">{`${moneda(pais)} ${(
                          comisionedificio || 0
                        ).toLocaleString(localString(pais), {
                          maximumFractionDigits: decimales(pais),
                          minimumFractionDigits: decimales(pais),
                        })}`}</td>
                        <td className="text-end ventas-facturas-neto-col">{`${moneda(pais)} ${neto.toLocaleString(localString(pais), {
                          maximumFractionDigits: decimales(pais),
                          minimumFractionDigits: decimales(pais),
                        })}`}</td>
                        <td className="text-end ventas-facturas-comision-comercial-col">{`${moneda(pais)} ${(
                          comisionvendedor || 0
                        ).toLocaleString(localString(pais), {
                          maximumFractionDigits: decimales(pais),
                          minimumFractionDigits: decimales(pais),
                        })}`}</td>
                        <td className="ventas-facturas-ejecutivo-col text-center">
                          {ejecutivo && ejecutivos[ejecutivo] ? ejecutivos[ejecutivo] : ejecutivo || "No asignado"}
                        </td>
                      </tr>
                    )
                  )
                )}
              </tbody>
            </table>
          </div>
        </div>
        {selectedOpportunity && (
          <BuildingDetailsModal
            opportunity={selectedOpportunity}
            buildings={edificios}
            moneda={moneda(pais)}
            localString={localString(pais)}
            decimales={decimales(pais)}
            onClose={() => setSelectedOpportunity(null)}
          />
        )}
      </div>
    </>
  );
};